import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { District, DistrictManipulationViewModel } from "./districtManipulation-viewModel"

export class DistrictManipulationView extends View<DistrictManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-DD31B85F-264B-4DA6-BF13-A67E5911DA34"
    }
    loadHtml(): string {
        let element = require('./districtManipulation.html').default;
        let style = require('./districtManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set districts(v: ObservableArray<District>) { this._districts = v; } public get districts(): ObservableArray<District> { return this._districts; } private _districts: ObservableArray<District>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;


    requestDistrictCreation() {
        this.dataContext.requestDistrictCreation();
    }
}
